import React from 'react';
import type { Switch as Interface } from '../../design/components';

export const Switch: React.FC<Interface> = ({
  name, description, state, hidden, inline, disabled, required, error
}) => {
  const [value, setValue] = state || [false, () => {}];

  // Inline mode: render just the checkbox
  if (inline) {
    return (
      <input
        id={name}
        name={name}
        type="checkbox"
        checked={!!value}
        disabled={disabled}
        required={required}
        onChange={(e) => setValue(e.target.checked)}
        style={{ width: '18px', height: '18px', display: hidden ? 'none' : undefined }}
      />
    );
  }

  return (
    <div style={{ marginBottom: '1rem', display: hidden ? 'none' : undefined }}>
      <label htmlFor={name} style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: disabled ? 'default' : 'pointer' }}>
        <input
          id={name}
          name={name}
          type="checkbox"
          checked={!!value}
          disabled={disabled}
          required={required}
          onChange={(e) => setValue(e.target.checked)}
          style={{ width: '18px', height: '18px' }}
        />
        <span style={{ fontWeight: 500 }}>
          {name}
          {required && <span style={{ color: 'red' }}> *</span>}
        </span>
      </label>
      {(error || description) && (
        <small style={{ color: error ? 'red' : '#666', display: 'block', marginTop: '4px' }}>
          {error || description}
        </small>
      )}
    </div>
  );
};
